/* esm.sh - applesauce-common@5.2.0/dist/register */
export * from "/*applesauce-common@5.2.0/esnext/dist/register.mjs";
